module.exports = __webpack_public_path__ + "static/media/50.e4dd80e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/50.svg
// module id = 157
// module chunks = 0